/**
 * @desc 财务画像-概述
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import { changeAnchor } from '../common/commons';
import FinancialFraud from './subComponents/FinancialFraud';
import FinancialRisk from './subComponents/FinancialRisk';

export default class Overview extends PureComponent {
    constructor(props) {
        super(props);
        this.nav = [
            { name: '财务舞弊', id: 'fraud' },
            { name: '财务风险', id: 'risk' }
        ];
    }

    componentDidMount() {
        changeAnchor(this.nav);
    }

    render() {

        return (
            <div>
                <div id="fraud" className="margin-bottom-40">
                    <FinancialFraud />
                </div>
                <div id="risk">
                    <FinancialRisk />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/overview/Overview.jsx